import { useMutation } from '@apollo/client';
import { Box, Button, FormControl, FormHelperText, FormLabel, GridItem, Input, Text, useToast,Grid } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { CHANGE_PASSWORD_MUTATION } from '../../Components/Graphql/Mutations';

const textStyles = {
  marginTop: '23px',
  fontSize: 'sm',
  marginBottom: '3px'
}

const inputStyles = {
  padding: '8px 15px',
  bgColor: '#F3F3F3',
  height: '46px',
  border: 'none',
  borderRadius: '5px',
  w: '100%',
  color: 'black',
  fontSize: '14px',
}

const ChangePassword = () => {

  const toast = useToast();
  const [changePasswordMutation, changePassword] = useMutation(CHANGE_PASSWORD_MUTATION);
  const [passwords, setPasswords] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [errors, setErrors] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate the form fields
    const { currentPassword, newPassword, confirmPassword } = passwords;
    let newErrors = {};

    if (newPassword.length < 6) {
      newErrors.newPassword = 'Password must be at least 6 characters';
    }

    // Validate password confirmation
    if (confirmPassword === '') {
      newErrors.confirmPassword = 'Please confirm your new password';
    } else if (confirmPassword !== newPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }

    // If there are errors, set the error state and return
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Reset errors
    setErrors({});



    try {
      console.log('Password change logic goes here:', passwords);
      const changePasswordInput = {
        currentPassword: passwords.currentPassword,
        newPassword: passwords.confirmPassword,
      };

      await changePasswordMutation({ variables: changePasswordInput });
    } catch (error) {
      toast({
        title: 'Error',
        description: error.message,
        status: 'error',
        duration: 4000,
        isClosable: true
      });
      console.log("Error from change password mutation: ", error);
    }

  };
  // Function to handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPasswords({ ...passwords, [name]: value });
  };

  useEffect(() => {
    console.log("passwords", passwords);
  }, [passwords]);
  useEffect(() => {

    console.log("error:", changePassword.error)
    console.log("loading:", changePassword.loading)
    console.log("data:", changePassword.data)

    if (changePassword.data != undefined) {
      if (changePassword?.data?.changePassword?.success) {
        toast({
          title: 'Succeed',
          description: 'Password is changed Successfully',
          status: 'success',
          duration: 4000,
          isClosable: true
        });
      }
      else {
        toast({
          title: 'error',
          description: changePassword?.data?.changePassword?.message,
          status: 'error',
          duration: 4000,
          isClosable: true
        });
      }

    }
    if (changePassword.error != undefined) {
      toast({
        title: 'error',
        description: changePassword.error.message,
        status: 'error',
        duration: 4000,
        isClosable: true
      });
    }
  }, [changePassword.data, changePassword.loading, changePassword.error])

  return (

    <Box w='100%'>
      <Text fontSize='20px' color='#333' marginLeft='30px' marginBottom='10px'>
        Change Password
      </Text>
      <Grid templateColumns={'repeat(12, 1fr)'} gap={3}>
        <GridItem colSpan={{ base: "12", lg: "6" }}>
          <Box color='#315B84' background='#FFFFFF' padding='20px 25px 35px 25px' borderRadius='15px'>
            <form onSubmit={handleSubmit}>
              <FormControl id="currentPassword" isRequired>
                <FormLabel {...textStyles} marginTop='0px'  >Old Password:</FormLabel>
                <Input
                  {...inputStyles}
                  type="password"
                  name="currentPassword"
                  onChange={handleInputChange}
                />
                {errors.currentPassword && (
                  <FormHelperText color="red">{errors.currentPassword}</FormHelperText>
                )}
              </FormControl>
              <FormControl id="newPassword" isRequired>
                <FormLabel {...textStyles} >New Password:</FormLabel>
                <Input
                  {...inputStyles}
                  type="password"
                  name="newPassword"
                  onChange={handleInputChange}
                />
                {errors.newPassword && (
                  <FormHelperText color="red">{errors.newPassword}</FormHelperText>
                )}
              </FormControl>
              <FormControl id="confirmPassword" isRequired>
                <FormLabel {...textStyles} >Confirm New Password:</FormLabel>
                <Input
                  {...inputStyles}
                  type="password"
                  name="confirmPassword"
                  onChange={handleInputChange}
                />
                {errors.confirmPassword && (
                  <FormHelperText color="red">{errors.confirmPassword}</FormHelperText>
                )}
              </FormControl>
              <Button
                type='submit'
                marginTop='40px'
                w='100%'
                fontWeight='400'
                backgroundColor='#0d6efd'
                color='white'
                _hover={{
                  backgroundColor: '#0a58ca'
                }}
              >
                Submit
              </Button>

            </form>

          </Box>
        </GridItem>
      </Grid>
    </Box>

  )
}

export default ChangePassword